export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortChanges<T> = {
  sortBy?: T | null | '';
  sortOrder?: SORT_DIRECTION | null | undefined;
};
